import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "modal-wrapper" }
const _hoisted_2 = { class: "status-content" }
const _hoisted_3 = { class: "bulk-info" }
const _hoisted_4 = { class: "status-options" }
const _hoisted_5 = { class: "status-grid" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "checkmark"
}
const _hoisted_8 = { class: "modal-actions" }
const _hoisted_9 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($props.isOpen)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "modal-overlay",
        onClick: _withModifiers($setup.closeModal, ["self"])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("div", { class: "modal-title" }, "Bulk Update Status")
          ], -1)),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("p", null, "Update status for " + _toDisplayString($props.selectedCount) + " selected lead" + _toDisplayString($props.selectedCount > 1 ? "s" : ""), 1)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _cache[0] || (_cache[0] = _createElementVNode("span", { class: "label" }, "Select Status", -1)),
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.values($setup.LeadStatus), (status) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["status-option", { selected: $setup.selectedStatus === status }]),
                    key: status,
                    onClick: ($event: any) => ($setup.selectStatus(status))
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["status-badge", $setup.getLeadStatusClass(status)])
                    }, _toDisplayString(status), 3),
                    ($setup.selectedStatus === status)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, "✓"))
                      : _createCommentVNode("", true)
                  ], 10, _hoisted_6))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              class: "btn cancel",
              onClick: $setup.closeModal
            }, "Cancel"),
            _createElementVNode("button", {
              class: "btn primary v2",
              onClick: $setup.confirmStatus,
              disabled: !$setup.selectedStatus
            }, "Done", 8, _hoisted_9)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}